'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pill = Pill;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./pill.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Pill component
 *
 * @example
 * <Pill>Some Pill</Pill>
 *
 * @example
 * <Pill velvet>Some Velvet Pill</Pill>
 */
function Pill(props) {
    var children = props.children;

    var className = (0, _classnames2['default'])('pill', { 'bg-velvet-evening c-white': props.velvet });

    return _react2['default'].createElement(
        'span',
        { className: className },
        children
    );
}

Pill.propTypes = {
    children: _react.PropTypes.string.isRequired,
    velvet: _react.PropTypes.bool
};

exports['default'] = Pill;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/pill.jsx
 ** module id = 1128
 ** module chunks = 0
 **/